export default __webpack_public_path__ + "static/media/qrcode.ec489b2a.svg";